var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 20.6a10.14 10.14 0 110-20.28 10.14 10.14 0 010 20.28zm5.63-12.48l-1.3-1.28-6.03 5.89-2.62-2.56-1.31 1.28 3.92 3.84z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--success-3e5f061eee57f1686bc14cb59b419ef8.svg";
export { SvgIconCircleSuccess as Component };